// eslint-disable-next-line import/no-self-import
import PropTypes from 'prop-types';

export const LatLongPropType = PropTypes.shape({
  latitude: PropTypes.number.isRequired,
  longitude: PropTypes.number.isRequired,
});

export const POIPropType = PropTypes.shape({});

export const CityPropType = PropTypes.shape({
  countryCode: PropTypes.string.isRequired,
});

export const CompanyPropType = PropTypes.shape({});

export const NewBookingDeliveryStepPropType = PropTypes.shape({
  poi: PropTypes.shape({}),
});

export const NewBookingDeliveryDetailConfigurationPropType = PropTypes.shape({
  serviceType: PropTypes.string,
  specialServiceType: PropTypes.string,
  vehicleType: PropTypes.string,
});

export const NewBookingDeliveryDetailPropType = PropTypes.shape({
  pickUp: NewBookingDeliveryStepPropType,
  dropOffs: PropTypes.arrayOf(NewBookingDeliveryStepPropType),
  configuration: NewBookingDeliveryDetailConfigurationPropType,
});

export const NewBookingConfigPropType = PropTypes.shape({});

export const NewBookingDeliveryPropType = PropTypes.shape({
  id: PropTypes.string,
  detail: NewBookingDeliveryDetailPropType,
  config: NewBookingConfigPropType,
});

export default {};
